// ============================================================================
// geoMessage.ts — КАНОНИЧЕСКИЙ формат «геометки» в сообщении чата (клиент).
//
// ВАЖНО (ограничение): серверных полей для типа сообщения «geo» НЕТ, поэтому
// геометка едет как ОБЫЧНЫЙ ТЕКСТ в каноническом виде, а превью-карта рисуется
// ЛОКАЛЬНО (components/geo/GeoMessagePreview). Ничего на сервере не выдумано.
//
// Формат: `📍 Геометка: <широта>, <долгота>` (метка — опционально, после « — »).
// ============================================================================

export interface GeoMessagePoint {
  lat: number;
  lon: number;
  /** Подпись точки (что это за место). */
  label: string;
}

const PREFIX = '📍 Геометка:';

/** Парсер геометки (детерминированный; координаты обязательны и валидны). */
const GEO_RE = /📍?\s*Геометка\s*:\s*(-?\d{1,3}(?:[.,]\d+)?)\s*[,;]\s*(-?\d{1,3}(?:[.,]\d+)?)\s*(?:—\s*(.+))?/i;

function num(v: string): number {
  return Number(String(v).replace(',', '.'));
}

/** Канонический текст сообщения-геометки. */
export function formatGeoMessage(p: GeoMessagePoint): string {
  const lat = p.lat.toFixed(6);
  const lon = p.lon.toFixed(6);
  const label = (p.label || '').trim();
  return label ? `${PREFIX} ${lat}, ${lon} — ${label}` : `${PREFIX} ${lat}, ${lon}`;
}

/** Разбор сообщения: геометка или null (обычный текст). */
export function parseGeoMessage(text: string): GeoMessagePoint | null {
  const m = GEO_RE.exec(String(text || ''));
  if (!m) return null;
  const lat = num(m[1]);
  const lon = num(m[2]);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  if (lat < -90 || lat > 90 || lon < -180 || lon > 180) return null;
  return { lat, lon, label: (m[3] || '').trim() };
}
